// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"ea4d64c3","135":"8d68b08a","256":"dacadade","338":"d3ff3422","407":"2c44ffcd","409":"debe2b34","463":"ebe12771","561":"672649e1","572":"c1b928b7","599":"00daddc3","604":"7159317f","641":"ddb6e9a9","804":"6a12fea9","855":"b2e143d0","879":"b2ce9ffc"}[chunkId] + ".chunk.js";
};